import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { deskimoPropertyCompanyListService } from "../../../../services/PropertyServices";
import { useDispatch, useSelector } from "react-redux";
import { deskimoDayOfficeFilterTmpSelector } from "../../../../selectors/PropertySelector";
import { deskimoDayOfficeFilterTmpAction } from "../../../../actions/PropertyActions";

const SelectPropertyCompany = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const filtersTmp = useSelector(deskimoDayOfficeFilterTmpSelector);

  const _initOptions = async (keyword = "") => {
    try {
      const { data } = await deskimoPropertyCompanyListService({
        keyword,
        page: 1,
      });

      const temp = data?.items?.map(
        ({
          company_id,
          company_name,
        }: {
          company_id: string;
          company_name: string;
        }) => {
          return {
            text: company_name,
            value: company_id,
          };
        }
      );
      setData(temp);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    (async () => {
      await _initOptions();
    })();
  }, []);

  const handleSearch = async (newValue: any) => {
    await _initOptions(newValue);
  };

  const handleChange = (newValue: any) => {
    dispatch(
      deskimoDayOfficeFilterTmpAction({
        ...filtersTmp,
        filter: { ...filtersTmp.filter, companies: newValue },
      })
    );
  };

  return (
    <>
      <Select
        showSearch
        value={filtersTmp.filter.companies}
        placeholder={"Select Property Company..."}
        mode={"multiple"}
        maxTagCount={"responsive"}
        style={{ width: "100%" }}
        defaultActiveFirstOption={false}
        suffixIcon={null}
        filterOption={false}
        onSearch={handleSearch}
        onChange={handleChange}
        notFoundContent={null}
        options={(data || []).map((d: any) => ({
          value: d.value,
          label: d.text,
        }))}
        removeIcon={<i className="uil uil-times-circle" />}
      />
    </>
  );
};

export default SelectPropertyCompany;
